"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppUsageStatsIn = void 0;
class AppUsageStatsIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return AppUsageStatsIn.attributeTypeMap;
    }
}
exports.AppUsageStatsIn = AppUsageStatsIn;
AppUsageStatsIn.discriminator = undefined;
AppUsageStatsIn.attributeTypeMap = [
    {
        "name": "appIds",
        "baseName": "appIds",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "since",
        "baseName": "since",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "until",
        "baseName": "until",
        "type": "Date",
        "format": "date-time"
    }
];
//# sourceMappingURL=AppUsageStatsIn.js.map